module.exports = __webpack_public_path__ + "img/home.27d5f20d.svg";